import { useState } from "react";

const MaintenanceBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  const show = process.env.NEXT_PUBLIC_SHOW_MAINTENANCE_NOTIFICATION === "true";
  const schedule = process.env.NEXT_PUBLIC_MAINTENANCE_SCHEDULE || "";

  if (!show || !schedule || dismissed) return null;

  return (
    <div className="sticky top-0 z-50 w-full bg-amber-50 border-b border-amber-300 px-4 py-2.5">
      <div className="flex items-center gap-2">
        {/* Spacer to visually center the message */}
        <div className="w-6 shrink-0" aria-hidden="true" />

        <p className="flex-1 text-center text-xs sm:text-sm font-medium text-amber-900 leading-5">
          🚧 Scheduled maintenance on {schedule}. Some services may be
          temporarily unavailable during this time.
        </p>

        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss maintenance notification"
          className="shrink-0 flex items-center justify-center w-6 h-6 rounded-full text-amber-700 hover:bg-amber-200 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
